export const CLASSIFICATION_COLORS: Record<string, string> = {
	critical: '#ffa39e',
	high: '#ffd591',
	low: '#d3adf7',
	medium: '#ffe58f'
};
